import * as React from 'react';

import * as classNames from "classnames";
import './NoteTypesPage.scss';

import { match } from "react-router";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import { routerActions } from 'react-router-redux';
import { Location, History } from "history";

import ReactSelectClass from "react-select";

import ReactTable, { Column, RowInfo } from 'react-table';



import * as ReactTooltip from 'react-tooltip';
import Alert from 'react-s-alert';

import { DefaultLayout, RestrictedLayout, UnrestrictedLayout, SubMenu } from "../../../components/layouts/index";

import * as NoteTypeActions from '../../../actions/noteType';
import * as PagingActions from '../../../actions/pages/pagingPage';

import * as Dtos from '../../../dtos/Tmd.dtos';
import { ITmdState, IFormFilter } from "../../../reducers/index";
import { RequestState } from "../../../enumerations/RequestState";
import { Link } from "../../../components/routing/index";
import { findLookup, generateOptionsFromLookup } from "../../../helpers/lookupHelper";
import { convertToShortDateString, convertToDateTimeString, convertToApproximateDateString } from "../../../helpers/date";
import { FontAwesomeIcon, FontAwesomeIcons } from "../../../constants/fontAwesomeIcons";
import { ILinkProps } from "../../../components/routing/Link";
import { INavItem } from "../../../components/layouts/NavMenu/NavMenu";
import { DEFAULT_PAGE_SIZE, PAGE_SIZE_OPTIONS } from "../../../constants/reactTableConstants";
import { setModalTitle } from "../../../helpers/modalHelper";
import { Modal, NotificationAlert } from "../../../components/common/index";

import * as AuthenticationHelper from '../../../helpers/authentication';
import * as AuthorisationDefinitions from '../../../constants/authorisationDefinitions';
import { ModalSize } from '../../../enumerations/ModalSize';
import { Form, actions, Control } from 'react-redux-form';
import { TextAreaFormInput, FormFilterInput } from '../../../components/form';

import { LookupsLayout } from '../../index';

interface INoteTypesPageProps {

    location: Location;
    history: History;

    // From state
    noteTypes: Dtos.NoteType[];
    formFilter: IFormFilter;
    formLength: number;

    loadingNoteTypes: boolean;
    loadNoteTypesSuccess: boolean;
    loadNoteTypesFailure: boolean;

    user: Dtos.User;
    permissions?: Dtos.PersonnelTmdPermissions[];
    formRoles?: Dtos.RoleType[];

    pageSize: number;
}

interface INoteTypesPageActions {
    clearNoteTypes: NoteTypeActions.INoteTypeClearActionCreator;
    loadNoteTypes: NoteTypeActions.INoteTypeLoadActionCreator;

    navigate: typeof routerActions.push;
    navigateReplace: typeof routerActions.replace;

    filter: NoteTypeActions.INoteTypeFilterActionCreator;

    setPageSize: PagingActions.IPagingPageSizeChangedStateActionCreator;
}

type NoteTypesPageProps = INoteTypesPageProps & INoteTypesPageActions;

const tableHeaderClass = "btn btn-primary btn-block rounded-0 p-3 d-flex"
const tableStyleClass: React.CSSProperties = {
    textAlign: "left",
    fontWeight: "bold",
    color: "white",
    cursor: "pointer"
}

class NoteTypesPage extends React.PureComponent<NoteTypesPageProps, any> {

    constructor(props: NoteTypesPageProps) {
        super(props);

        this.clearNoteTypes = this.clearNoteTypes.bind(this);
    }

    componentDidMount() {
        const {
            loadNoteTypes
        } = this.props;

        loadNoteTypes();
    }

    componentWillReceiveProps(nextProps: NoteTypesPageProps) {
    }

    componentDidUpdate(prevProps: NoteTypesPageProps, prevState) {
        const {
            navigateReplace
        } = this.props
    }

    componentWillUpdate(nextProps: NoteTypesPageProps) {
    }

    componentWillUnmount() {
        this.clearNoteTypes();
    }

    clearNoteTypes() {
        this.props.clearNoteTypes();
    }

    showNoteTypes(): boolean {
        const {
            loadingNoteTypes,
            loadNoteTypesSuccess
        } = this.props

        if (!loadingNoteTypes && loadNoteTypesSuccess) {
            return true;
        }

        return false;
    }

    render() {

        const {
            loadingNoteTypes
        } = this.props;

        return <LookupsLayout loading={loadingNoteTypes} permission={Dtos.Permission.NoteTypesView}>
            {this.renderContent()}
        </LookupsLayout>;
    }

    renderContent() {
        const {
            permissions
        } = this.props;

        return <div>
            <div className="row">
                <div className={"col-6 mb-2"}>
                    <h2>Note Types</h2>
                </div>
                <div className="col-6" style={{ textAlign: 'right' }}>
                    <FormFilterInput formFilter={this.props.formFilter} onFilter={e => this.props.filter(e)} />
                    {AuthenticationHelper.hasPermission(permissions, Dtos.Permission.NoteTypesCreate) && (
                        <Link className={"btn btn-primary"} url={"/settings/general/notetypes/create"}>Create</Link>
                    )}
                </div>
            </div>
            {
                !this.showNoteTypes() ?
                    "Loading Note Types" :
                    null
            }
            {
                this.showNoteTypes() ?
                    <div className="patient-tables mt-2">
                        {
                            this.createTable()
                        }
                    </div> :
                    null
            }
        </div>
    }

    createTable() {

        const {
            noteTypes,
            pageSize,
            setPageSize
        } = this.props

        if (!noteTypes || noteTypes.length == 0) {
            return <div className="alert alert-info d-flex">
                <div className="mr-2">
                    <FontAwesomeIcon icon={FontAwesomeIcons.Solid.INFO_SQUARE} fixedWidth />
                </div>
                <span>There are currently no note types to view.</span>
            </div>
        }

        const showPagination = noteTypes.length > pageSize;

        return <div className="table-wrapper mb-3">
            <ReactTable
                data={noteTypes}
                pageSizeOptions={PAGE_SIZE_OPTIONS}
                defaultPageSize={showPagination ? pageSize : noteTypes.length}
                pageSize={showPagination ? pageSize : noteTypes.length}
                showPagination={showPagination}
                className="-striped -highlight -clickable mb-3"
                noDataText="There are currently no noteTypes to display"
                resizable={false}
                onPageSizeChange={val => setPageSize(val)}
                getTdProps={(state, rowInfo: RowInfo, column, instance) => {
                    return {
                        onClick: (e, handleOriginal) => {

                            const url: string = "/settings/general/notetypes/" + rowInfo.original.id;
                            this.props.navigate(url);

                            if (handleOriginal) {
                                handleOriginal()
                            }

                        }
                    }
                }}
                columns={[
                    {
                        id: "id",
                        Header: ' ',
                        accessor: "id",
                        className: "d-flex align-items-center justify-content-center",
                        maxWidth: 50,
                        Cell: (props) => <FontAwesomeIcon icon={FontAwesomeIcons.Light.LOOKUP} fixedWidth />
                    },
                    {
                        id: "value",
                        Header: 'Name',
                        accessor: 'value',
                        className: "d-flex align-items-left justify-content-left",
                        headerClassName: "text-left"
                    }
                ]}
            />
        </div>

    }

}

const mapStateToProps = (state: ITmdState, ownProps: NoteTypesPageProps): INoteTypesPageProps => {

    let permissions = state.user.userSummary ? state.user.userSummary.permissions : [];

    return {

        history: ownProps.history,
        location: state.routing.location,

        noteTypes: state.noteTypes.formFilteredData!,
        formFilter: state.noteTypes.formFilter,
        formLength: state.noteTypes.formLength,

        loadingNoteTypes: state.noteTypes.loadState && state.noteTypes.loadState.status == RequestState.Pending,
        loadNoteTypesSuccess: state.noteTypes.loadState && state.noteTypes.loadState.status == RequestState.Success,
        loadNoteTypesFailure: state.noteTypes.loadState && state.noteTypes.loadState.status == RequestState.Failure,

        user: state.user.data,
        permissions: permissions,
        formRoles: state.user.formRoles,

        pageSize: state.pagingPage.pageSize
    };
};

const mapDispatchToProps = (dispatch): INoteTypesPageActions => {
    return {
        navigate: bindActionCreators(routerActions.push, dispatch),
        navigateReplace: bindActionCreators(routerActions.replace, dispatch),

        loadNoteTypes: bindActionCreators(NoteTypeActions.LoadNoteType, dispatch),
        clearNoteTypes: bindActionCreators(NoteTypeActions.Clear, dispatch),

        filter: bindActionCreators(NoteTypeActions.Filter, dispatch),

        setPageSize: bindActionCreators(PagingActions.PageSizeChanged, dispatch)
    };
};

export default
    connect(mapStateToProps, mapDispatchToProps)(NoteTypesPage);
